import React from "react";
import Box from "./box";

interface YouTubeEmbedProps {
  videoId: string; // The YouTube video ID
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ videoId }) => {
  return (
    <Box
      localStyles={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%",
        borderRadius: 24,
        overflow: "hidden",
        boxShadow: "0 2px 0 0 rgba(0,0,0,1), 0 -2px 0 0 rgba(255,255,255,0.2)",
        background: "#343434",
      }}
    >
      <iframe
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          border: 0,
        }}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Box>
  );
};

export default YouTubeEmbed;
